<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="true"
  [maximizable]="true"
  [baseZIndex]="10001"
  [style]="{ width: '55vw', maxWidth: '750px' }"
  styleClass="comment-modal-dialog"
  (onHide)="onHide()">
  
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center gap-3">
        <div class="header-icon-wrapper">
          <i class="fa-solid fa-comment-dots"></i>
        </div>
        <div>
          <h2 class="text-xl font-semibold text-white m-0">
            Comments
          </h2>
          <p class="text-sm text-white/80 m-0">{{ ticket?.title || 'Ticket' }}</p>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="comment-container-new">
    <!-- Comments List - Top Section -->
    <div class="comments-section">
      <div *ngIf="comments.length === 0" class="empty-state-new">
        <div class="empty-icon">
          <i class="fa-solid fa-comments"></i>
        </div>
        <h3 class="empty-title">No Comments Yet</h3>
        <p class="empty-text">Start the conversation by adding the first comment</p>
      </div>

      <div class="comments-timeline">
        <div 
          *ngFor="let comment of comments; let i = index" 
          class="comment-bubble-wrapper"
          [class.current-user]="comment.userId === currentUser">
          
          <div class="comment-bubble">
            <div class="bubble-header">
              <div class="user-badge">
                <span class="user-initial">{{ comment.userName.charAt(0).toUpperCase() }}</span>
              </div>
              <div class="bubble-meta">
                <span class="bubble-author">{{ comment.userName }}</span>
                <span class="bubble-time">{{ getRelativeTime(comment.createdAt) }}</span>
              </div>
            </div>
            <div class="bubble-content">
              <p>{{ comment.comment }}</p>
            </div>
            <div class="bubble-footer">
              <i class="fa-solid fa-clock"></i>
              <span>{{ formatDate(comment.createdAt) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Comment Input - Bottom Section -->
    <div class="input-section-new">
      <div class="input-container">
        <div class="input-wrapper">
          <div class="current-user-badge">
            <span>{{ currentUser.charAt(0).toUpperCase() }}</span>
          </div>
          <textarea
            [(ngModel)]="commentText"
            rows="3"
            placeholder="Type your comment here..."
            class="comment-input-new"
            (keydown.enter)="$event.preventDefault(); onSubmitComment()"
            (keydown.enter.shift)="true">
          </textarea>
          <button
            class="send-button"
            (click)="onSubmitComment()"
            [disabled]="!commentText.trim()"
            [class.disabled]="!commentText.trim()">
            <i class="fa-solid fa-paper-plane"></i>
          </button>
        </div>
        <div class="input-hint">
          <span>Press Enter to send, Shift+Enter for new line</span>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end">
      <button
        pButton
        type="button"
        label="Close"
        class="p-button-text p-button-secondary"
        (click)="onClose()">
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-toast></p-toast>

